jQuery(window).bind('load',function(){
  	// Catalog menu carousel
  	jQuery('.navslider').flexslider({
        animation: "slide",
        animationLoop: false,
        itemWidth: 125,
        itemMargin: 1,
        controlNav: false
      });
    jQuery('.navslider .flex-direction-nav a').html('');
  	var $container = jQuery("#masonry-container");
    var $window = jQuery(window);
    // start up isotope with default settings
  	if($container) {
      $container.imagesLoaded( function(){
          jQuery('.prod-image-wrap').animate({opacity: '1'},200);
          $container.isotope({
            animationEngine: "best-available",
            itemSelector: ".item",
            resizable: true,
            layoutMode: 'masonry',
            masonry: {
              columnWidth: 10
            }
          });
        return false;
      });
  	}
  	//Display menu at smaller screen sizes
    jQuery('#nav-menu-button').on('click', function(evt) {
        if(jQuery('#main-nav-menu').css('display')=='none'){ //Show the menu, except the last item
          jQuery('#main-nav-menu').fadeIn();
        } else { //Hide the menu
          jQuery('#main-nav-menu').fadeOut(); 
        }
      });
    jQuery(window).resize(function(){//Ensure the menu is in the correct state when the user resizes
      if(jQuery(window).width()>1170){
        if(jQuery('#main-nav-menu').css('display')=='none'){ //Show the menu, except the last item
          jQuery('#main-nav-menu').fadeIn();
        }       
      }
    });
	//Display Collection submenu
    jQuery('#nav-catalog').on('mouseenter touchend', function(evt) {
      if(jQuery(window).width()>979){//Only in non-mobile
        openCollectionMenu(jQuery('#collection-nav'),'100px');
      }
      return false;
    });
    jQuery('#branding').on('mouseenter', function(evt) {
      if(jQuery(window).width()>979){//Only in non-mobile
        closeCollectionMenu(jQuery('#collection-nav'),'0');
      }
    });
    jQuery('#main').on('mouseenter', function(evt) {
      closeCollectionMenu(jQuery('#collection-nav'),'0');
    });
    jQuery('#customer-log-in').on('click touchend', function(evt) {
      loadCollectionMenu(jQuery('#log-in-section'),'45px');
      return false;
	});
  	// Filter off the tags on the collection page
    jQuery('.collection-filter').on('click', function(evt) {
      jQuery(this).parents('.collection-tags').find('.active').removeClass('active');
    });    
});
function openCollectionMenu(target,newheight){
	//Load the specified element
	height = target.height();
	if(height==0){
		jQuery(target).css('display','block');
		jQuery(target).animate({height: newheight},200);
	}
}
function loadCollectionMenu(target,newheight){
	//Load the specified element
	height = target.height();
	if(height==0){
		jQuery(target).css('display','block');
		jQuery(target).animate({height: newheight},200);
	} else {
		jQuery(target).animate({height: '0'},200,function(){
			jQuery(target).css('display','none'); 
		});
	}
}
function closeCollectionMenu(target,newheight){
	//Hide the menu
	height = target.height();
	if(height!=0){
		jQuery(target).animate({height: newheight},200,function(){
			jQuery(target).css('display','none');
		})
	}
}